<!-- Animated SVG checkmark icon that draws in when shown. -->

<script setup lang="ts">
defineProps({
  show: { type: Boolean, default: true },
});
</script>

<template>
  <svg
    viewBox="0 0 11 10"
    :class="[css.tick, show && css.show]"
  >
    <path d="M1 5.95L4.26534 9.21534C4.65787 9.60787 5.31725 9.51409 5.58477 9.02768L10 1" />
  </svg>
</template>

<style module="css" lang="scss">
.tick {
  width: 1em;
  fill: none;
  stroke: currentColor;
  stroke-width: 1;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 16px;
  stroke-dashoffset: 16px;
  transform: translate3d(0, 0, 0);
}

.show {
  animation: tick 0.2s 0.1s ease-out forwards;
}

@keyframes tick {
  from {
    transform: scale(1);
    stroke-dashoffset: 16px;
  }
  50% {
    stroke-dashoffset: 8px;
    transform: scale(0.9);
  }
  to {
    transform: scale(1);
    stroke-dashoffset: 0;
  }
}
</style>
